import script from "./ServicesDistribution.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesDistribution.vue?vue&type=script&setup=true&lang=js"

import "./ServicesDistribution.vue?vue&type=style&index=0&id=59234cba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59234cba"]])

export default __exports__